import { FC, PropsWithChildren, Suspense, useEffect, useState } from 'react';


import { ArrowUpOutlined } from '@ant-design/icons';
import { Affix, FloatButton, Layout, theme } from 'antd';

import { Breadcrumb, CustomHeader, SideMenu } from './components';

import MasterService from '../../services/master';
import { MenuOption } from '../../interfaces';
import Tutorials from '../../../pages/virtualOffice/Tutorials/components';

const { Content } = Layout;
interface MainLayoutProps extends PropsWithChildren {
  showBreadcrumb?: boolean;
}

const MAIN_LAYOUT_CONTENT_ID ='custom-main-layout';

export const scrollToTop = () => document.getElementById( MAIN_LAYOUT_CONTENT_ID )?.scrollTo({ top: 0, behavior: 'smooth' });

export const MainLayout: FC<MainLayoutProps> = ({
  children,
  showBreadcrumb = true,
}) => {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const [listMenu, setListMenu] = useState<Array<MenuOption>>([])

  const getListMenu = async () => {
    try {
      const response = await MasterService.getListMenus();

      if( response.data ) {
        setListMenu( response.data.menues )
      }
    } catch (error) {}
  }

  useEffect(() => {
    getListMenu();
    /* eslint-disable-next-line */
  }, [])

  return (
    <>
      {listMenu && (
        <Layout>
          <CustomHeader menus={listMenu} />

          <Layout>
            <Affix offsetTop={64}>
              <SideMenu menus={listMenu} />
            </Affix>

            <Layout
              style={{
                padding: '0 24px 24px',
                height: 'calc(100vh - 64px)',
                overflow: 'auto',
                background: colorBgContainer,
              }}
              id={ MAIN_LAYOUT_CONTENT_ID }
            >
              {
                showBreadcrumb && <Breadcrumb menus={listMenu} />
              }
              
              <Content
                style={{
                  margin: 0,
                  minHeight: '100vh',
                  borderRadius: borderRadiusLG,
                  width: '100%',
                }}
              >
                <Suspense fallback={<></>}>{children}</Suspense>
              </Content>

              <FloatButton.BackTop
                icon={<ArrowUpOutlined />}
                target={() => document.getElementById('main-layout-content')!}
                visibilityHeight={200}
              />

            </Layout>
          </Layout>
        </Layout>
      )}
    </>
  )
};
